import React from 'react';
import ReactDOM from 'react-dom';
import { configureStore } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import FeedbackList from '../FeedbackList';
import FeedbackDetail from '../FeedbackDetail';
import SearchBar from '../SearchBar';
import StatsBar from '../StatsBar';
import StatsTable from '../StatsTable';
import Modal from '../Modal';
import Loading from '../Loading';
import Table from '../Table';

import {connectWebsocket, updateModalContent} from '../redux/FeedbackRedux';

class EditBusinessGroup extends React.Component {
    componentDidMount() {
        this.props.dispatch(connectWebsocket());
    }

    handleAddUser(event) {
        var modal_id = "addUserBGModal";
        var modal_title =  __("Add Users To Business Group");
        var modal_body =  __("Add users to business groups here");
        var button_1_class = "outline-secondary";
        var button_1_id = "cancel";
        var button_1_text =  __("cancel");
        var button_2_class = "primary";
        var button_2_id = "AddUser";
        var button_2_text =  __("Save Changes");
        this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
        jQuery('.modal:not(.error)').modal();

    }

    handleAddBusiness(event) {
        var modal_id = "addbusinessBGModal";
        var modal_title =  __("Add businesses To Business Group");
        var modal_body =  __("Add businesses to business groups here");
        var button_1_class = "outline-secondary";
        var button_1_id = "cancel";
        var button_1_text = "cancel";
        var button_2_class = "primary";
        var button_2_id = "AddBusiness";
        var button_2_text =  __("Save Changes");
        this.props.dispatch(updateModalContent({modal_id:modal_id,modal_title:modal_title,modal_body:modal_body,button_1_class:button_1_class,button_1_id:button_1_id,button_1_text:button_1_text,button_2_class:button_2_class,button_2_id:button_2_id,button_2_text:button_2_text}));
        jQuery('.modal:not(.error)').modal();
    }

    render() {
        return (
            <div className="container-fluid">
                <Loading location={'page'} />
                <div className="row business-group">
                    <Table condensed={true} data={this.props.state.table_data??null}/>
                </div>
                <div className="row businesses">
                    <Table condensed={true} addButton={this.handleAddBusiness.bind(this)} data={this.props.state.business_table_data??null}/>
                </div>
                <div className="row users">
                    <Table condensed={true} addButton={this.handleAddUser.bind(this)} data={this.props.state.users_table_data??null}/>
                </div>

                <Modal modal={this.props.state.modal}/>

            </div>
        );
        }
}

function mapStateToProps(state) {
    return { state:state }
}

export default connect(mapStateToProps)(EditBusinessGroup);
